import React, {useState, useEffect} from "react"
import {AsyncResultModal} from "../../AsyncResultModal/AsyncResultModal"
import Admonition from "../../Admonitions/Admonition"
import {AsyncResultIdleRequestState} from "../../../types/asyncResultIdle"
import {ErrorDocument} from "../../../resources/common"

export default function ConfirmationModalContent<T>(props: {
	close: () => void
	onSuccess: () => void
	onError?: (error?: ErrorDocument) => void
	enableReevaluateApplication: boolean
	onSubmit: (reason: string) => void
	state: AsyncResultIdleRequestState<T, ErrorDocument>
}) {
	const {close, onSuccess, onError, enableReevaluateApplication, onSubmit, state} = props
	const [reason, setReason] = useState("")

	useEffect(() => {
		state.match(
			() => null,
			() => null,
			() => null,
			(error) => {
				onError?.(error)
			}
		)
	}, [state])

	const modalTitle = enableReevaluateApplication
		? "The application will be resubmitted"
		: "Update Application Evaluation Information"

	const buttonText = enableReevaluateApplication ? "Yes, Resubmit Application" : "Update without resubmission"

	const warningMessage = enableReevaluateApplication ? (
		<p>
			Resubmitting will overwrite the current application data and cannot be undone. The application will be locked for
			further changes until its evaluation is completed.
		</p>
	) : (
		<p>
			Resubmission is not enabled for this application. The changes will be saved, but the application will <b>not</b>{" "}
			be resubmitted for evaluation
		</p>
	)

	return (
		<AsyncResultModal
			close={close}
			onSuccess={onSuccess}
			onSubmit={() => onSubmit(reason)}
			buttonClassname="is-outlined"
			state={state}
			successText="Resubmit is approved"
			buttonText={buttonText}
			// Insert spaces before capital letters in camelCase/PascalCase and lowercase the result
			errorToText={(e) => e.errors[0].title.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase()}
			title={modalTitle}
		>
			<label htmlFor="reason">Please specify the reasons for the requested changes:</label>
			<textarea
				onChange={(e) => setReason(e.target.value)}
				required
				rows={3}
				id="reason"
				className="textarea has-fixed-size mb-6 mt-2"
			/>

			<Admonition type="is-warning" title="Attention" message={warningMessage} />
		</AsyncResultModal>
	)
}
